/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Rang, dans `data`, de chacun des quatre parents d'un acte de mariage.
 *
 * ⚠️ Pourquoi une table plutôt que des noms parlants : le `ParentForm` de
 * `@mairistem/administres-utils` construit ses noms de champs à partir du seul
 * `numeroParent` (`parent{n}.nomFamille`, `filiationInconnueParent{n}`) et
 * n'offre pas de préfixe. Les quatre parents d'un mariage occupent donc les
 * rangs 1 à 4 de `data`, et non `parent1Conjoint1`… — alors que l'écran, lui,
 * affiche « Parent 1 » et « Parent 2 » sur chacune des deux étapes.
 *
 * Cette table est la seule traduction entre les deux : les étapes, les
 * validators et `buildActeMariagePayload` la lisent. Le payload, lui, garde les
 * noms parlants du contrat d'API.
 */
export const RANGS_PARENTS_MARIAGE = {
  /** Parents du 1er conjoint : `data.parent1` et `data.parent2`. */
  conjoint1: [1, 2] as const,
  /** Parents du 2ème conjoint : `data.parent3` et `data.parent4`. */
  conjoint2: [3, 4] as const,
};

/** Clé de `data` portant l'état matrimonial du couple de parents d'un conjoint. */
export const cleEtatMatrimonialParents = (numeroConjoint: 1 | 2) =>
  `etatMatrimonialParentsConjoint${numeroConjoint}`;

export default RANGS_PARENTS_MARIAGE;
